import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs'

@Injectable()
export class FeatureFlagsService {

    constructor(private http: HttpClient) { }

    getFlags(): Observable<IFlagsModel> {
        return this.http.get<IFlagsModel>('/_mvc/booking/featureflags')
    }

    disable() {
        this.getFlags = () => of({ flags: {} })
    }

}

export interface IFlagsModel {
    flags: { [key: string]: any }
}
